module.exports = __webpack_public_path__ + "partylineManage/img/cloudProxy.0bc6ae7a.png";